import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import Article from '../components/article';

export default ({ data: { prismicArticle: node }, location: { pathname } }) => {
    const articleProps = {
        pathname,
        uid: node.uid,
        image: node.data.image,
        title: node.data.title.text,
        body: node.data.body.html,
        bodyText: node.data.body.text,
        tags: node.tags,
        author: node.data.author,
        date: (new Date(node.last_publication_date)).toLocaleDateString('en-US', {
            day: 'numeric',
            year: 'numeric',
            month: 'short'
        })
    };

    return <Layout pathname={pathname}><Article {...articleProps} /></Layout>;
};

export const query = graphql`
    query ArticleQuery($uid: String!) {
        prismicArticle(uid: { eq: $uid }) {
            last_publication_date
            tags
            uid
            data {
                title {
                    text
                }
                body {
                    text
                    html
                }
                image {
                    url
                    dimensions {
                        width
                        height
                    }
                    localFile {
                        childImageSharp {
                            fluid(maxWidth: 976, maxHeight: 400, quality: 100, cropFocus: CENTER) {
                                ...GatsbyImageSharpFluid_withWebp
                            }
                        }
                    }
                }
                author
            }
        }
    }
`;
